import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        user: [],
        trekking_agency:[],
        loading: false,
        mobile_number:null,
        warnings:[],
    }
}

const getters = {
    loading: state => state.loading,
    user: state => state.user,
    trekking_agency:state => state.trekking_agency,
    mobile: state => state.mobile_number,
    warnings: state => state.warnings,

}

const actions = {
    fetchCurrentUser({
        commit,
        state
    }) {
        if (state.user.length ===0) {
            commit('setLoading', true)
            Http.get(API_URL + VERSION + '/user')
                .then(response => {
                    commit('setUser', response.data.data);
                    commit('setAgency', response.data.data.trekking_agency);
                })
                .catch(error => {})
                .finally(() => {
                    commit('setLoading', false)
                })
        }
    },
    reFetchCurrentUser({
        commit,
        state
    }) {
        commit('setLoading', true)
        Http.get(API_URL + VERSION + '/user')
            .then(response => {
                commit('setUser', response.data.data)
                commit('setAgency',response.data.data.trekking_agency)
            })
            .catch(error => {})
            .finally(() => {
                commit('setLoading', false)
            })
    },
    register({
        commit,
        state
    }, data) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/trekking-agency/register', data)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
                .finally(() => {
                    commit('setLoading', false)
                })
        });
    },
    resetState({
        commit
    }) {
        commit('resetState')
    },

    getTrekkingAgencyStatus({
        commit,
        state
        }){
            Http.get(API_URL + VERSION + "/status/" + state.trekking_agency.id)
                .then(response => {
                    console.log(response.data.message);
                })
                .catch(error => {
                    commit('setWarnings', error.response.data.warning);
            });
    },

    changePassword({
                       commit,
                   }, data) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/change-password/save', data)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
}

const mutations = {
    setUser(state, items) {
        state.user = items
    },
    setAgency(state, items) {
        state.trekking_agency = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setMobile(state, mobile_number) {
        state.mobile_number = mobile_number
    },
    setWarnings(state, warnings) {
        state.warnings = warnings
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
